import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ isPermission, children }) => {
    if (!isPermission) return <Navigate to="/" replace />;
    return children;
};
